import React, { Component } from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import { toastr } from 'react-redux-toastr'
import { history } from '../../_helpers'
import Loading from '../Shared/Loading'
import { appUsersService } from '../../_services/AppUsers.service'
import accessTypes from '../../_constants/accessTypes'
import GenderSelectForAdmin from '../Shared/GenderSelectForAdmin'
import RoleSelect from '../Shared/RoleSelect'
import ErrorPopUp from '../Shared/ErrorPopUp'
import UnionSelectForAdmin from '../Shared/UnionSelectForAdmin'

import Checkbox from '../Shared/Checkbox'
import FormikCheckbox from '../Shared/FormikCheckbox'
import { Formik, Field, ErrorMessage, getIn } from 'formik'
import * as Yup from 'yup'

import PasswordHelper from '../Shared/PasswordHelper'
import owasp from 'owasp-password-strength-test'

owasp.config({
  allowPassphrases: false,
  minLength: 8
})

class EditAppUser extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      modelId: this.props.match.params.id,
      loading: true,
      model: {},
      key: 'info',
      passwordValue: '',
      passwordTestStatus: {
        minLengthTestPasses: false
        // maxLengthTestPasses: true,
        // repeatedCharactersTestPasses: true,
        // containsUppercaseLetterTestPasses: false,
        // containsLowercaseLetterTestPasses: false,
        // containsNumberTestPasses: false,
        // containsSpecialCharacterTestPasses: false
      }
    }
  }

  componentWillMount() {
    this.getData()
  }

  getData() {
    // console.log(this.props.match.params.id);

    appUsersService.getById(this.props.match.params.id).then(res => {
      // console.log(res.data);
      var data = res.data

      let valuesPermissions = []
      accessTypes.forEach(item => {
        let index = data.permissions.findIndex(
          e => e.accessType == item.accessType
        )
        if (index == -1) {
          valuesPermissions.push({ accessType: item.value, access: false })
        } else {
          valuesPermissions.push({
            accessType: item.value,
            access: data.permissions[index].access
          })
        }
      })

      data['permissions'] = valuesPermissions
      data['password'] = ''
      if (valuesPermissions !== undefined) {
        this.setState({ model: data, loading: false })
      } else {
        this.getData()
      }
    })
  }

  onPasswordChange = (e, setFieldValue) => {
    const { failedTests: failed, passedTests: passed } = owasp.test(
      e.target.value
    )
    const testDefinitelyPassed = testIndex => {
      // console.log(!failed.includes(testIndex) && passed.includes(testIndex));
      return !failed.includes(testIndex) && passed.includes(testIndex)
    }

    // const { setFieldTouched, setFieldValue } = this.props;
    setFieldValue('password', e.target.value)
    // setFieldTouched("password");

    this.setState({
      passwordValue: e.target.value,
      passwordTestStatus: {
        minLengthTestPasses: testDefinitelyPassed(0)
        // maxLengthTestPasses: testDefinitelyPassed(1),
        // repeatedCharactersTestPasses: testDefinitelyPassed(2),
        // containsLowercaseLetterTestPasses: testDefinitelyPassed(3),
        // containsUppercaseLetterTestPasses: testDefinitelyPassed(4),
        // containsNumberTestPasses: testDefinitelyPassed(5),
        // containsSpecialCharacterTestPasses: testDefinitelyPassed(6)
      }
    })
  }

  handleSubmit = values => {
    this.setState({ loading: true })
    // console.log(JSON.stringify(values));

    appUsersService
      .edit(JSON.stringify(values))
      .then(res => {
        this.setState({ loading: false })
        toastr.success(
          'ویرایش کاربر',
          'کاربر  "' +
            this.state.model.firstName +
            ' ' +
            this.state.model.lastName +
            '" با موفقیت ویرایش شد'
        )
        history.push('/admin/user')
      })
      .catch(error => {
        // console.log(error);
        this.handleError(error)
      })
  }

  handleError(error) {
    this.setState({ loading: false })
    // toastr.warning('مشکلی پیش آمد', error);
  }

  render() {
    const {
      minLengthTestPasses
      // maxLengthTestPasses,
      // repeatedCharactersTestPasses,
      // containsLowercaseLetterTestPasses,
      // containsUppercaseLetterTestPasses,
      // containsNumberTestPasses,
      // containsSpecialCharacterTestPasses
    } = this.state.passwordTestStatus

    const passwordHelperCriteria = [
      {
        value: minLengthTestPasses,
        description: 'طول کلمه عبور حداقل باید 8 کاراکتر باشد'
      }
      // { value: maxLengthTestPasses, description: "128 characters maximum" },
      // {
      //   value: repeatedCharactersTestPasses,
      //   description: "No more than 3 repeated characters in a row"
      // },
      // {
      //   value: containsLowercaseLetterTestPasses,
      //   description: "کلمه عبور باید حداقل شامل یک حرف کوچک باشد"
      // },
      // {
      //   value: containsUppercaseLetterTestPasses,
      //   description: "کلمه عبور باید حداقل شامل یک حرف بزرگ باشد"
      // },
      // {
      //   value: containsNumberTestPasses,
      //   description: "کلمه عبور باید حداقل شامل یک کاراکتر عددی باشد"
      // },
      // {
      //   value: containsSpecialCharacterTestPasses,
      //   description: "کلمه عبور باید حداقل شامل یک کاراکتر خاص باشد"
      // }
    ]

    const ValidationSchema = Yup.object().shape({
      gender: Yup.string()
        .trim()
        .nullable()
        .required('جنسیت'),
      firstName: Yup.string()
        .trim()
        .nullable()
        .required('نام'),
      lastName: Yup.string()
        .trim()
        .nullable()
        .required('نام خانوادگی'),
      mobile: Yup.string()
        .nullable()
        .matches(/^[0-9]\d{10}$/, {
          message: 'تلفن همراه باید شامل 11 رقم باشد',
          excludeEmptyString: false
        })
        .trim()
        .required('وارد کردن [تلفن همراه] الزامی است'),

      userName: Yup.string()
        .trim()
        .nullable()
        .required('نام کاربری'),

      changePassword: Yup.bool(),
      password: Yup.string()
        .nullable()
        .when('changePassword', {
          is: true,
          then: Yup.string()
            // .matches(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*()-_+=/\|?.><])(?=\S+$).{8,}$/, { message: "کلمه عبور باید شامل موارد زیر باشد", excludeEmptyString: false })
            .min(8, 'طول کلمه عبور حداقل باید 8 کاراکتر باشد')
            .trim()
            .required('وارد کردن کلمه عبور الزامی است')
        }),

      userType: Yup.number(),
      unionId: Yup.string().when('userType', {
        is: 1,
        then: Yup.string()
          .trim()
          .nullable()
          .required('اتحادیه')
      }),

      email: Yup.string()
        .email('صحیح ایمیل')
        .trim()
        .nullable()
        .required('ایمیل')
    })
    const { model, loading } = this.state
    return (
      <div>
        {!this.state.loading ? (
          <div>
            <Formik
              initialValues={model}
              onSubmit={(values, { setSubmitting }) => {
                // console.log(JSON.stringify(values));
                this.handleSubmit(values)
                setSubmitting(false)
              }}
              validationSchema={ValidationSchema}>
              {props => {
                const {
                  values,
                  touched,
                  errors,
                  // dirty,
                  setFieldValue,
                  // setFieldTouched,
                  // isSubmitting,
                  // handleChange,
                  // handleBlur,
                  handleSubmit
                  // handleReset,
                  // validateForm
                } = props
                return (
                  <div>
                    <div className="row" style={{ position: 'relative' }}>
                      <form onSubmit={handleSubmit}>
                        <Tabs
                          transition={false}
                          id="controlled-tab-example"
                          activeKey={this.state.key}
                          onSelect={key => this.setState({ key })}>
                          <Tab eventKey="info" title="مشخصات کاربر">
                            <div className="row">
                              <div className="col-md-11">
                                <div className="form-inline adminForm">
                                  <div className="col-lg-1 col-sm-12 text-left">
                                    <label />
                                  </div>
                                  <div className="col-lg-3 col-sm-12">
                                    <Field
                                      component={FormikCheckbox}
                                      name="isActive"
                                      id="isActive"
                                      label={'کاربر فعال است'}
                                    />
                                  </div>
                                  <div className="clearfix form-row" />

                                  <div className="col-lg-1 col-sm-12 text-left">
                                    <label>نوع کاربر</label>
                                  </div>
                                  <div
                                    className={
                                      'col-lg-3 col-sm-12 ' +
                                      (touched.userType &&
                                        errors.userType &&
                                        'has-error')
                                    }>
                                    <RoleSelect
                                      name="userType"
                                      value={values.userType}
                                      defaultValue={values.userType}
                                      onChange={val => {
                                        setFieldValue('userType', val)
                                        if (val === 0) {
                                          setFieldValue('unionId', undefined)
                                        }
                                      }}
                                    />
                                    <ErrorPopUp
                                      error={errors.userType}
                                      touched={touched.userType}
                                      type="select"
                                    />
                                  </div>

                                  <div className="col-lg-1 col-sm-12 text-left">
                                    <label>اتحادیه</label>
                                  </div>
                                  <div
                                    className={
                                      'col-lg-7 col-sm-12 ' +
                                      (touched.unionId &&
                                        errors.unionId &&
                                        'has-error')
                                    }>
                                    <UnionSelectForAdmin
                                      name="unionId"
                                      disabled={values.userType !== 1}
                                      defaultValue={values.unionId}
                                      onChange={val => {
                                        setFieldValue('unionId', val)
                                      }}
                                    />
                                    <ErrorPopUp
                                      error={errors.unionId}
                                      touched={touched.unionId}
                                      type="select"
                                    />
                                  </div>

                                  <div className="clearfix form-row" />

                                  <div className="col-lg-1 col-sm-12 text-left">
                                    <label>جنسیت</label>
                                  </div>
                                  <div
                                    className={
                                      'col-lg-3 col-sm-12 ' +
                                      (touched.gender &&
                                        errors.gender &&
                                        'has-error')
                                    }>
                                    <GenderSelectForAdmin
                                      name="gender"
                                      value={values.gender}
                                      defaultValue={values.gender}
                                      onChange={val => {
                                        setFieldValue('gender', val)
                                      }}
                                    />
                                    <ErrorPopUp
                                      error={errors.gender}
                                      touched={touched.gender}
                                      type="select"
                                    />
                                  </div>

                                  <div className="col-lg-1 col-sm-12 text-left">
                                    <label>نام</label>
                                  </div>
                                  <div className="col-lg-3 col-sm-12">
                                    <Field
                                      type="text"
                                      name="firstName"
                                      className={
                                        getIn(errors, 'firstName') &&
                                        getIn(touched, 'firstName')
                                          ? 'text-input fa has-error'
                                          : 'text-input fa'
                                      }
                                    />
                                    <ErrorMessage
                                      component={ErrorPopUp}
                                      name="firstName"
                                    />
                                  </div>

                                  <div className="col-lg-1 col-sm-12 text-left">
                                    <label>نام خانوادگی</label>
                                  </div>
                                  <div className="col-lg-3 col-sm-12">
                                    <Field
                                      type="text"
                                      name="lastName"
                                      className={
                                        getIn(errors, 'lastName') &&
                                        getIn(touched, 'lastName')
                                          ? 'text-input fa has-error'
                                          : 'text-input fa'
                                      }
                                    />
                                    <ErrorMessage
                                      component={ErrorPopUp}
                                      name="lastName"
                                    />
                                  </div>

                                  <div className="clearfix form-row" />

                                  <div className="col-lg-1 col-sm-12 text-left">
                                    <label>تلفن همراه</label>
                                  </div>
                                  <div className="col-lg-3 col-sm-12">
                                    <Field
                                      type="text"
                                      name="mobile"
                                      className={
                                        getIn(errors, 'mobile') &&
                                        getIn(touched, 'mobile')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                      }
                                    />
                                    <ErrorPopUp
                                      error={errors.mobile}
                                      touched={touched.mobile}
                                      type="fullText"
                                    />
                                  </div>

                                  <div className="col-lg-1 col-sm-12 text-left">
                                    <label>ایمیل</label>
                                  </div>
                                  <div className="col-lg-3 col-sm-12">
                                    <Field
                                      type="email"
                                      name="email"
                                      className={
                                        getIn(errors, 'email') &&
                                        getIn(touched, 'email')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                      }
                                    />
                                    <ErrorMessage
                                      component={ErrorPopUp}
                                      name="email"
                                    />
                                  </div>

                                  <div className="col-lg-1 col-sm-12 text-left">
                                    <label>نام کاربری</label>
                                  </div>
                                  <div className="col-lg-3 col-sm-12">
                                    <Field
                                      type="text"
                                      autoComplete="off"
                                      name="userName"
                                      className={
                                        getIn(errors, 'userName') &&
                                        getIn(touched, 'userName')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                      }
                                    />
                                    <ErrorMessage
                                      component={ErrorPopUp}
                                      name="userName"
                                    />
                                  </div>

                                  <div className="clearfix form-row" />
                                  <div className="col-lg-1 col-sm-12 text-left">
                                    <label>سطح دسترسی</label>
                                  </div>
                                  <div className="col-lg-11 col-sm-12">
                                    {accessTypes.map((item, index) => (
                                      <div>
                                        <Checkbox
                                          label={item.name}
                                          value={
                                            values.permissions &&
                                            values.permissions.filter(
                                              el => el.accessType == item.value
                                            )[0] &&
                                            values.permissions.filter(
                                              el => el.accessType == item.value
                                            )[0].access
                                          }
                                          onChange={() => {
                                            let items = values.permissions
                                            console.log(items)
                                            const currentIndex = values.permissions.findIndex(
                                              el => el.accessType == item.value
                                            )
                                            const newItems = [...items]

                                            let newItem = newItems[currentIndex]
                                            newItem.access = !newItem.access
                                            newItems[currentIndex] = newItem

                                            setFieldValue(
                                              'permissions',
                                              newItems
                                            )
                                          }}
                                        />
                                      </div>
                                    ))}
                                  </div>

                                  <div className="clearfix form-row" />
                                  <hr />

                                  <div className="col-lg-1 col-sm-12 text-left">
                                    <label />
                                  </div>
                                  <div className="col-lg-3 col-sm-12">
                                    <Field
                                      component={FormikCheckbox}
                                      name="changePassword"
                                      id="changePassword"
                                      label={'تغییر کلمه عبور'}
                                    />
                                  </div>
                                  <div className="clearfix form-row" />

                                  <div className="col-lg-1 col-sm-12 text-left">
                                    <label>کلمه عبور</label>
                                  </div>
                                  <div className="col-lg-5 col-sm-12">
                                    <Field
                                      type="password"
                                      disabled={!values.changePassword}
                                      autoComplete="off"
                                      id="password"
                                      name="password"
                                      value={this.state.passwordValue}
                                      onChange={e =>
                                        this.onPasswordChange(e, setFieldValue)
                                      }
                                      className={
                                        getIn(errors, 'password') &&
                                        getIn(touched, 'password')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                      }
                                    />
                                    <ErrorPopUp
                                      error={errors.password}
                                      touched={touched.password}
                                      type="fullText"
                                    />
                                  </div>

                                  <div className="col-lg-1 col-sm-12 text-left">
                                    <label>تکرار کلمه عبور</label>
                                  </div>
                                  <div className="col-lg-5 col-sm-12">
                                    <Field
                                      type="password"
                                      disabled={!values.changePassword}
                                      name="confirmPassword"
                                      className={
                                        getIn(errors, 'confirmPassword') &&
                                        getIn(touched, 'confirmPassword')
                                          ? 'text-input has-error'
                                          : 'text-input'
                                      }
                                    />
                                    <ErrorPopUp
                                      error={errors.confirmPassword}
                                      touched={touched.confirmPassword}
                                      type="fullText"
                                    />
                                  </div>
                                  <div className="clearfix form-row" />
                                  <div className="col-lg-1 col-sm-12 text-left">
                                    <label />
                                  </div>
                                  <div
                                    className={
                                      !values.changePassword
                                        ? 'col-lg-5 col-sm-12 hidden'
                                        : 'col-lg-5 col-sm-12'
                                    }>
                                    <PasswordHelper
                                      criteria={passwordHelperCriteria}
                                      disabled={!values.changePassword}
                                    />
                                  </div>

                                  <div className="col-md-12 ">
                                    <button
                                      type="submit"
                                      className="icon button submit-btn pull-left">
                                      ذخیره
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Tab>
                        </Tabs>
                      </form>
                    </div>
                    {this.state.loading ? <Loading /> : ''}
                  </div>
                )
              }}
            </Formik>
          </div>
        ) : (
          <Loading />
        )}
      </div>
    )
  }
}
export default EditAppUser
